export default class EvoTalksSyncStatusModel {
  evoTalksAtivo!: boolean;

  contactSynced!: boolean;

  companySynced!: boolean;

  evoClientId?: string | null;
}
